import CustomInput, { Props as CustomInputProps } from '../../../../components/CustomInput/CustomInput';

interface Props {
    baseInputProps: Omit<CustomInputProps, 'name'>;
}

const Form = (props: Props) => {
    const { baseInputProps } = props;

    return (
        <>
            <CustomInput {...baseInputProps} name='name' />
            <CustomInput {...baseInputProps} name='description' rows={4} multiline />
        </>
    );
};

export default Form;
